import { ActionHandler } from '../actionHandler';
import { Spinner } from '../spinner';

const sizes = {
  sm: 'py-1.5 px-3 space-x-1 [&_svg]:w-3.5 [&_svg]:h-3.5 text-sm',
  md: 'py-2 px-4 space-x-2 [&_svg]:w-4 [&_svg]:h-4',
  lg: '',
  xl: ''
};

const colors = {
  default: 'bg-slate-100  hover:bg-slate-200/70',
  red: 'bg-red-600 text-white',
  green: 'bg-green-600 text-white',
  amber: 'bg-amber-600 text-white',
  blue: 'bg-blue-600 hover:bg-blue-700 text-white'
};

const defaultClasses = 'rounded-full font-hmedium inline-flex truncate items-center';

export interface ButtonInterface {
  loading: bool;
  label: string;
  icon: ReactComponent;
  color: 'default' | 'red' | 'green' | 'blue';
  size: 'sm' | 'md' | 'lg' | 'xl';
}

export function Button({
  loading = false,
  label,
  icon,
  iconRight,
  color = 'default',
  size = 'md',
  className = '',
  ...rest
}: ButtonInterface) {
  const Icon = icon;
  const IconRight = iconRight;

  return (
    <ActionHandler {...rest} disabled={loading || rest.disabled}>
      <span className={`${colors[color]} ${sizes[size]} ${defaultClasses} ${className}`}>
        {!loading && Icon && (
          <span className="flex-shrink-0">
            <Icon />
          </span>
        )}
        {!!loading && (
          <span className="inline-flex mr-1">
            <Spinner color="white" />
          </span>
        )}
        <span className="flex-shrink">{label}</span>
        {!loading && IconRight && (
          <span className="flex-shrink-0">
            <IconRight />
          </span>
        )}
      </span>
    </ActionHandler>
  );
}
